/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  useEffect,
  useLayoutEffect,
  createContext,
  ReactElement,
} from 'react';
import { css, jsx } from '@emotion/core';
import GraphCircle from './GraphCircle';
import GraphBar from './GraphBar';
import { interactionContext as _interactionContext } from './interactionContext';

const GraphContainer = () => {
  const interactionContext = useContext(_interactionContext);
  const { score, passed } = interactionContext;
  const { graphType, graphColor } = interactionContext.props;

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 30px;
      `}
    >
      {/* <Graph src="assets/graph.svg" /> */}
      {graphType === 'circle' ? (
        <GraphCircle color={graphColor} score={Number(score)} />
      ) : (
        <GraphBar color={graphColor} score={Number(score)} />
      )}
    </div>
  );
};

export default GraphContainer;
